<script lang="ts">
  import { toasts } from "../stores/toasts.svelte";
</script>

<!-- No aria-live on the container: each toast is its own live region via role,
     and nesting live regions causes duplicate/erratic announcements. -->
<div class="toaster" data-focus-trap-exempt>
  {#each toasts.items as toast (toast.id)}
    <div class="toast tone-{toast.kind}" role={toast.kind === "error" ? "alert" : "status"}>
      <div class="toast-body">
        <p class="toast-msg">{toast.message}</p>
        {#if toast.correlationId}<p class="toast-ref mono">Reference: {toast.correlationId}</p>{/if}
      </div>
      <button type="button" class="toast-close" aria-label="Dismiss" onclick={() => toasts.dismiss(toast.id)}>
        <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" /></svg>
      </button>
    </div>
  {/each}
</div>

<style>
  .toaster {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 150;
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: min(400px, calc(100vw - 40px));
  }
  .toast {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 16px;
    border-radius: var(--radius-btn);
    border: 1px solid var(--line-soft);
    background: var(--surface-2);
    box-shadow: var(--shadow-md);
    animation: toast-in var(--dur-enter) var(--ease-out);
  }
  @media (prefers-reduced-motion: reduce) {
    .toast {
      animation: none;
    }
  }
  @keyframes toast-in {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
  }
  .tone-success {
    border-color: var(--accent-border);
  }
  .tone-error {
    border-color: var(--err-border);
  }
  .tone-info {
    border-color: var(--line-bright);
  }
  .toast-body {
    flex: 1 1 auto;
  }
  .toast-msg {
    margin: 0;
    font-size: 14px;
    color: var(--text);
  }
  .toast-ref {
    margin: 6px 0 0;
    font-size: 12px;
    /* --muted on --surface-2 is 4.29:1; --text-soft clears AA at 6.2:1 and stays
     * clearly subordinate to the message above it. */
    color: var(--text-soft);
  }
  .toast-close {
    flex: none;
    width: 26px;
    height: 26px;
    display: grid;
    place-items: center;
    border-radius: 6px;
    border: none;
    background: transparent;
    color: var(--muted);
    cursor: pointer;
  }
  .toast-close:hover {
    color: var(--heading);
  }
  .toast-close svg {
    width: 14px;
    height: 14px;
  }
</style>
